import React from 'react'

const Pie = () => {
  return (
    <footer className="footer footer-center bg-grey py-8"> {/* static mt-auto */}
        <aside>
          <p> © 2023 - E-Commerce CRUD</p>
        </aside>
    </footer>
  )
}

export default Pie